import PropTypes from 'prop-types';

const columnType = PropTypes.oneOfType([
  PropTypes.string, PropTypes.number, PropTypes.node, PropTypes.array,
]).isRequired;

const statType = PropTypes.oneOfType([
  PropTypes.exact({ href: PropTypes.string, stat: columnType }),
  PropTypes.arrayOf(columnType),
]).isRequired;

const statsType = PropTypes.arrayOf(statType);

export default statsType;
